import { CallScribeCallStatus } from 'services/callScribe/types';

export type TResumeVerdict = 'resumable' | 'terminal' | 'started' | 'unknown';

const REQUIRED_FIELDS = ['status', 'startedAtUtc', 'endedAtUtc'] as const;

const carriesRequiredFields = (call: object): boolean =>
  REQUIRED_FIELDS.every(field => Object.prototype.hasOwnProperty.call(call, field));

export const resumeVerdict = (call: unknown): TResumeVerdict => {
  if (call === null || typeof call !== 'object') {
    return 'unknown';
  }
  if (!carriesRequiredFields(call)) {
    return 'unknown';
  }

  const { status, startedAtUtc, endedAtUtc } = call as {
    status: unknown;
    startedAtUtc: unknown;
    endedAtUtc: unknown;
  };

  if (status !== CallScribeCallStatus.Initiated) {
    return 'terminal';
  }
  if (startedAtUtc != null || endedAtUtc != null) {
    return 'started';
  }
  return 'resumable';
};

export const RESUME_BLOCKED_TEXT =
  "This call can't be resumed. Place the call again.";
